import React from 'react';
import {
	useForm,
	FormSupplier,
	useFormSupplier,
	DoneTypingEvent,
} from 'formydable';
import { Render, Notification } from 'myt-react-notify';
export const MockSubmit = (event) => {
	if (event.isReady()) {
		MockRequest('/mock/json/request', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: event.json(),
		})
		.then((response) => {
			Alerto(response.json(), 'success');
		}) 

		event.reset(); 
		
	} else {
		Alerto('Failed! all field rules must fulfilled', 'danger');
		event.locateFailed();
	}
};
export const FormWrapper = ({ children, onSubmit }) => {
	const { formState, formUpdate, formRegistry, formSubmit } = useForm();

	const formSubmitHandler = formSubmit(onSubmit);

	return (
		<FormSupplier value={{ formState, formUpdate, formRegistry }}>
			<form onSubmit={formSubmitHandler}>
				{children}
				<button type='submit' className='n-btn'>
					Submit
				</button>
			</form>
		</FormSupplier>
	);
};

export const InputWithRules = ({
	type = 'text',
	name,
	label,
	rules,
	value = '',
	placeholder = 'enter here...',
	id,
}) => {
	const { formState, formUpdate, formRegistry } = useFormSupplier();

	formRegistry({ name, label, rules, value });

	const fieldstate = formState(name);

	const validity = fieldstate.isInvalid
		? 'n-form-invalid'
		: fieldstate.isValidated
		? 'n-form-valid'
		: '';

	return (
		<div className={`n-form-field ${validity}`}>
			<label htmlFor={id || name}>
				{label}
				{rules.includes('required') && (
					<span className='label-required'>*</span>
				)}
			</label>
			<input
				className='n-form-control'
				id={id || name}
				type={type}
				name={name}
				value={type !== 'file' ? fieldstate.value : undefined}
				placeholder={placeholder}
				onChange={formUpdate}
			/>
			<div className='n-invalid-feedback'>{fieldstate.message}</div>
			<div className='n-valid-feedback'><span role='img' aria-label="checked">✔️</span> Looks good!</div>
		</div>
	);
};

export const InputDoneTypingWithRules = ({
	type = 'text',
	name,
	label,
	rules,
	placeholder = 'enter here...',
}) => {
	const { formState, formUpdate, formRegistry } = useFormSupplier();

	if (rules) {
		formRegistry({ name, label, rules });
	}

	const fieldstate = formState(name);

	const handleDoneTyping = DoneTypingEvent((event) => {
		formUpdate({ target: event.target });
	}, 300);

	const validity =
		(fieldstate &&
			(fieldstate.isInvalid
				? 'n-form-invalid'
				: fieldstate.isValidated && 'n-form-valid')) ||
		'';

	return (
		<div className='n-form-field'>
			<label htmlFor={name}>
				{label}
				{rules.includes('required') && (
					<span className='label-required'>*</span>
				)}
			</label>
			<input
				id={name}
				type={type}
				name={name}
				placeholder={placeholder}
				className={`n-form-control ${validity}`}
				{...handleDoneTyping}
			/>
			<div className='n-invalid-feedback'>{fieldstate && fieldstate.message}</div>
			<div className='n-valid-feedback'>Looks good!</div>
		</div>
	);
};

const fileString = (files) =>
	Object.keys(files).reduce((result, index) => {
		return (result += `     ${index}: File {
	  name:${files[index].name},
	  lastModified:${files[index].lastModified},
	  size:${files[index].size},
	  type:${files[index].type}
    }\n`);
	}, ' {\n') + '  }';

const stringifyObject = (json) =>
	Object.keys(json).reduce(
		(result, key) =>
			(result += `  ${key}:${
				typeof json[key] === 'string'
					? json[key]
					: Array.isArray(json[key])
					? `[${json[key]}]`
					: fileString(json[key])
			}\n`),
		'{\n'
	) + '}';

export const Alerto = (message, variant) => {
	Render(<Notification template={{ message, variant }} />);
};
export const MockRequest = (url, { method, body, headers }) => {
	return new Promise((resolve) => {
		Render(
			<Notification id={url} placement='top-right' delay={10000}>
				{(show) => (
					<div className='n-float-low px-4 py-3 br-5'>
						<div className='d-flex flex-center-y'>
							<h5>Request Success!</h5>
							<button
								className='n-btn n-btn-xs ml-auto'
								type='button'
								onClick={() => show(false)}>
								×
							</button>
						</div>
						<pre>
							<code>
								url: {url},{'\n'}method: {method},{'\n'}headers:
								{stringifyObject(headers)},{'\n'}body:{' '}
								{typeof body === 'string' ? body : stringifyObject(body)}
							</code>
						</pre>
					</div>
				)}
			</Notification>
		);
		setTimeout(() => {
			resolve({
				json() {
					return 'Success! the form is submited';
				},
			});
		}, 1000);
	});
};
